<template>
    <div class="grid-content">
        <div class="grid-item grid-item-full">
            <v-select
                :async-find="doSearch"
                :async-get-init-value="getInitValues"
                :label="label"
                :select-id="vselectId"
                :value="selectedTags"
                @is-removed="onOption(names.removed, $event)"
                @is-selected="onOption(names.selected, $event)"
                :loading="loading"
                allow-empty
                clear-on-select
                hide-selected
                multiple
                option-key="name"
                option-label="name"
                placeholder="Type to search tag"
            />
        </div>
    </div>
</template>


<script>
    import {vSelect} from '@/components/form';


    export default {
        name: 'select-tags',
        components: {vSelect},
        props: {
            label: {
                type: String,
                default: 'Search',
            },
            vselectId: {
                type: String,
                required: true,
            },
            selectedTags: {
                type: Array,
                required: true,
            },
            doSearch: {
                type: Function,
                required: true,
            },
            getInitValues: {
                type: Function,
                required: true,
            },
            loading: Boolean,
        },

        data() {
            return {
                tags: [],
                names: {
                    selected: 'selected',
                    removed: 'removed',
                },
            };
        },

        methods: {
            /**
             * @param {String} action Action callback identifier
             * @param {TagModel} value Selected tag
             * @param {String} instanceId v-select instance id
             */
            onOption(action, {value, instanceId}) {
                this.$emit(`option-${action}`, {tag: value, instanceId});
            },
        },
    };
</script>
